<app-modal-actionable iconSrc="assets/ico/shape.svg" title="Link" color="purple" [data]="data"
    dataIconSrc="assets/ico/shape.svg">
    <div icon class="modal-icon icon fill-white" aria-label="file" [inlineSVG]="'assets/ico/link.svg'"></div>
    <div content>
        <apc-action-card>
            <apc-save-back-action-buttons buttons></apc-save-back-action-buttons>
            <div content class="fullwidth">
                <div class="container-fluid">
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label>Tipologia</label>
                            <select class="form-control">
                                <option>Generic</option>
                            </select>
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Data inizio validità</label>
                            <input class="form-control" type="date" />
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Data fine validità</label>
                            <input class="form-control" type="date" />
                        </div>
                        <div class="form-group col-lg-2 bell-icon">
                            <apc-ui-switch>
                                <span label>
                                    <div class="icon" aria-label="bell"
                                        [inlineSVG]="'assets/ico/notifications_active.svg'"></div>
                                </span>
                            </apc-ui-switch>
                        </div>
                        <div class="form-group col-lg-4 mt-3">
                            <label>Nome</label>
                            <input class="form-control" type="text" />
                        </div>
                        <div class="form-group col-lg-8 mt-3">
                            <label>URL</label>
                            <input class="form-control" type="text" />
                        </div>
                        <div class="form-group col-lg-12 mt-4">
                            <label>Descrizione</label>
                            <textarea class="form-control" type="text" placeholder="Descrizione generica…"
                                rows="8"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </apc-action-card>
    </div>
</app-modal-actionable>